<template>
<div class="chapter">
<div class="inner_page">
<p class="OT"><a id="page_v">Contents</a></p><a id="page_v">
</a><p class="TocSb1" id="pre"><a id="page_v"></a><a href="#/xhtml/preface#pre">Preface</a></p>
<p class="Toc" id="ch-001"><a href="#/xhtml/chapter001#ch001">1.<span class="space1">Digging in the Dirt and in the Bible</span></a></p>
<p class="Toc" id="ch-002"><a href="#/xhtml/chapter002#ch002">2.<span class="space1">Patriarchs, Matriarchs, and Migrations: Where Is the Promised Land?</span></a></p>
<p class="Toc" id="ch-003"><span href="#/xhtml/chapter003#ch003" title="Link target outside of Sample">3.<span class="space1">Yahweh versus Pharaoh: Holy War</span></span></p>
<p class="Toc" id="ch-004"><span href="#/xhtml/chapter004#ch004" title="Link target outside of Sample">4.<span class="space1">Israel Settles in Its Land of Promise—or Peril?</span></span></p>
<p class="Toc" id="ch-005"><span href="#/xhtml/chapter005#ch005" title="Link target outside of Sample">5.<span class="space1">Yahweh Comes to the Rescue: Divine Kingship</span></span></p>
<p class="Toc" id="ch-006"><span href="#/xhtml/chapter006#ch006" title="Link target outside of Sample">6.<span class="space1">Israel, a Nation among the Nations: Divine Destiny—and Disaster</span></span></p>
<p class="Toc" id="ch-007"><span href="#/xhtml/chapter007#ch007" title="Link target outside of Sample">7.<span class="space1">Religion and Cult: How Many Gods?</span></span></p>
<p class="Toc1a" id="con"><span href="#/xhtml/conclusion#con" title="Link target outside of Sample">Conclusion</span></p>
<p class="Toc1" id="bib"><span href="#/xhtml/bibliography#bib" title="Link target outside of Sample">Suggested Readings</span></p>
<p class="Toc1" id="ill"><span href="#/xhtml/backmatter001#ill" title="Link target outside of Sample">Sources for Illustrations</span></p>
<p class="Toc1" id="idx-001"><span href="#/xhtml/index001#idx001" title="Link target outside of Sample">Index</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?badf3e3e